export const paths = {
  landingPage: () => '/get-started',
}
